import React from "react";
import { joinClasses } from "../../../utils/joinClasses";
import { Icon } from "../../icon/Icon";
export const Checkbox = ({ checked, children, className, disabled, hasError, ...inputProps }) => (React.createElement("label", { className: joinClasses(["nxm-checkbox-field", className], {
        "nxm-checkbox-checked": checked,
        "nxm-checkbox-disabled": disabled,
        "nxm-checkbox-error": hasError,
    }) },
    React.createElement("input", { checked: checked, className: "nxm-checkbox-input", disabled: disabled, type: "checkbox", ...inputProps }),
    React.createElement("span", { className: "nxm-checkbox" },
        React.createElement(Icon, { className: "nxm-checkbox-icon", path: "mdiCheck", size: "sm" })),
    React.createElement("span", { className: "nxm-checkbox-label" }, children)));
